import React from "react";
import { Routes, Route, Navigate } from "react-router-dom";
import AdminDashboard from "../pages/admin/dashboard/dashboard";
import Mediums from "../pages/admin/mediums/mediums";
import MediumView from "../pages/admin/mediumprofileview";
import MediumPricingView from "../pages/admin/mediumpricingview";
import MediumShareItForward from "../pages/admin/mediumShareItForward";
import ClientView from "../pages/admin/clientprofileview";
import Appointments from "../pages/admin/appointments";
import Clients from "../pages/admin/clients";
import Feedback from "../pages/admin/feedback";
import BackFillAdmin from "../pages/admin/backfill";
import InspirationStories from "../pages/admin/inspirationstories";
// import TermsAndConditions from "../pages/termsandcondition";
import MediumEdit from "../pages/admin/mediumprofiledit";
import ClientEdit from "../pages/admin/clientprofiledit";
import Requests from "../pages/admin/requests";
import Support from "../pages/admin/support";
import Calendar from '../pages/admin/calendar';
import PractitionerInfo from "../pages/admin/professionalPublicView";
import Survey from "../pages/admin/survey";
import FeedBackRequests from "../pages/admin/feedbackrequests";
import Transaction from "../pages/admin/transactions";
import Refunded from "../pages/admin/refunded";
import Availability from "../pages/availability/availability";
import ReferralCodes from "../pages/admin/referrals";
import OnboardingBooking from "../pages/onboardingbooking";
import PayMyMedium from '../pages/paymymedium';
import VerifyEmail from "../pages/admin/calendar/verifyemail";
import ClientExport from "../pages/admin/clientexport";
import OnDemandUpdates from "../pages/admin/ondemandupdates";
import LiveOnDemandEvents from "../pages/admin/liveeventsondemands";
import OnDemandHistory from "../pages/admin/ondemandehistory";
import UserDetectedTimeZones from "../pages/admin/userdetectedtimezones";
import ScheduleStatus from "../pages/admin/mediums/schedulestatus";
import Topic from "../pages/admin/topic";
import BlockedMediums from "../pages/admin/blockedmediums";
import UrlSubmission from "../pages/admin/urlsubmission";
import Exports from "../pages/admin/exports";
import GoogleCalendarLogs from "../pages/admin/googlecalendarlogs";
import EmailLogs from "../pages/admin/emaillogs";
import DeletedUsers from "../pages/admin/deletedusers";
// import Comingsoon from "../pages/comingsoon";
// import Privacy from "../pages/privacy";

const AdminRoutes = () => {
  return (
    <Routes>
      <Route path="/" element={<Navigate to="/dashboard" />} />
      <Route path="/dashboard" element={<AdminDashboard />} />
      <Route path="/mediums" element={<Mediums />} />
      <Route path="/schedule-status/:id" element={<ScheduleStatus />} />
      <Route path="/public-view/:id" element={<PractitionerInfo show={false} />} />
      <Route path="/profile-view/:id" element={<MediumView />} />
      <Route path="/backfill-view/:id" element={<BackFillAdmin />} />
      <Route path="/profile-edit/:id" element={<MediumEdit />} />
      <Route path="/view/:id" element={<ClientView />} />
      <Route path="/edit/:id" element={<ClientEdit />} />
      <Route path="/appointments" element={<Appointments />} />
      <Route path="/clients" element={<Clients />} />
      <Route path="/feedbacks" element={<Feedback />} />
      <Route path="/inspiration-stories" element={<InspirationStories />} />
      <Route path="/requests" element={<Requests />} />
      <Route path="/system-updates" element={<Support />} />
      <Route path="/services" element={<Calendar />} />
      <Route path="/survey" element={<Survey />} />
      <Route path="/feedback-requests" element={<FeedBackRequests />} />
      <Route path="/transactions" element={<Transaction />} />
      <Route path="/refunded" element={<Refunded />} />
      <Route path="/availability/:id" element={<Availability />} />
      <Route path="/referrals" element={<ReferralCodes />} />
      <Route path="/paymymedium/:id" element={<PayMyMedium />} />
      <Route path="/verifyemail" element={<VerifyEmail />} />
      <Route path="/client-export" element={<ClientExport />} />
      <Route path="/on-demand-updates" element={<OnDemandUpdates />} />
      <Route path="/live-events-ondemand" element={<LiveOnDemandEvents />} />
      <Route path="/ondemand-history" element={<OnDemandHistory />} />
      <Route path="/user-detected-timezones" element={<UserDetectedTimeZones />} />
      <Route path="/topic" element={<Topic />} />
      <Route path="/url-submission" element={<UrlSubmission />} />
      <Route path="/blocked-mediums" element={<BlockedMediums />} />
      <Route path="/exports" element={<Exports />} />
      <Route path="/google-calendar-logs" element={<GoogleCalendarLogs />} />
      <Route path="/email-logs" element={<EmailLogs />} />
      <Route path="/deleted-users" element={<DeletedUsers />} />
      <Route path="/pricing-view/:id" element={<MediumPricingView />} />
      {/* Admins testing the medium-only link get told why, not bounced silently. */}
      <Route path="/onboarding-booking/:mediumId" element={<OnboardingBooking />} />
      <Route path="/share-it-forward/:id" element={<MediumShareItForward />} />

      <Route path="*" element={<Navigate to="/" />} />
    </Routes>
  );
};
export default AdminRoutes;
